export default {
  chapters: 'Kapitel',
  bookmarks: 'Lesezeichen',
  highlights: 'Hervorhebungen',
  bookInfo: 'Buchinfo',
  author: 'Autor',
  title: 'Titel',
  page: 'seite',
  pages: 'seiten',
  chaptersTitle: 'Inhalt',
  bookInfoTitle: 'Informationen zum Buch',
  bookmarksTitle: 'Lesezeichen',
  notesTitle: 'Notizen',
  fileName: 'Dateiname',
  year: 'Jahr',
  format: 'Format',
  fileSize: 'Dateigröße',
  loadingBook: 'Buch wird geladen',
  textSize: 'Textgröße',
  textColor: 'Hintergrundfarbe',
  appearenceTitle: 'Aussehen',
  viewMode: 'Textfluss',
  addNote: 'Notiz hinzufügen',
  editNote: 'Notiz bearbeiten',
  addBookmark: 'Lesezeichen hinzufügen',
  deleteHighlight: 'Hervorhebung löschen',
  default: 'Standard',
  of: 'von',
  onePage: 'Eine Seite',
  twoPages: 'Zwei Seiten',
  scrolling: 'Blättern',
  zoom: 'Skalierung',
  found: 'Gefunden',
  searchResults: 'suchergebnisse',
  searchResult: 'suchergebnis',
  searchResultsThanFive: 'suchergebnis',
  notFound: 'Nicht gefunden',
  errorInfo: 'Ein Fehler ist aufgetreten.',
  closeReaderBtn: 'Zurück zu der Bibiliothek',
  genres: 'Genre',
  isbn: 'ISBN',
  annotation: 'Anmerkung',
  authors: 'Autoren',
  publisher: 'Herausgeber',
  series: 'Buchreihen',
  filter: 'Filter',
  export: 'Notizen exportieren'
}



// WEBPACK FOOTER //
// ./src/locale/de-DE/reader.js